// Generated by CoffeeScript 2.7.0
// ==============================================================================
// MODULES - COMPONENTS - ALT TEXT
// ==============================================================================
import $ from "jquery";

$(function() {
  window.altText = function() {
    return $('.JS--altText').each(function() {
      var $this;
      $this = $(this);
      return $this.html($this.attr('data-text'));
    });
  };
  return window.altText();
});
